import { useEffect, useState } from "react";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#place", label: "The Place" },
    { href: "#experiences", label: "Experiences" },
    { href: "#stay", label: "Stay" },
    { href: "#restore", label: "Restore" },
    { href: "#taste", label: "Taste" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background-50/85 backdrop-blur-xl border-b border-foreground-950/10"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10 py-4 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span
            className={`w-5 h-5 flex items-center justify-center border rounded-full transition-colors ${
              scrolled ? "border-foreground-950/40" : "border-background-50/70"
            }`}
          >
            <i
              className={`ri-landscape-line text-[10px] ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            ></i>
          </span>
          <span
            className={`eyebrow tracking-[0.32em] transition-colors ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            Alpine Retreat
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`eyebrow transition-colors cursor-pointer ${
                scrolled
                  ? "text-foreground-700 hover:text-foreground-950"
                  : "text-background-50/85 hover:text-background-50"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a
            href="#book"
            className={`eyebrow whitespace-nowrap px-4 py-2.5 border transition-colors cursor-pointer ${
              scrolled
                ? "border-foreground-950/40 text-foreground-950 hover:bg-foreground-950 hover:text-background-50"
                : "border-background-50/60 text-background-50 hover:bg-background-50 hover:text-foreground-950"
            }`}
          >
            Reserve
          </a>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
            scrolled ? "text-foreground-950" : "text-background-50"
          }`}
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          <i className={`ri-${open ? "close" : "menu"}-line text-xl`}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-background-50/95 backdrop-blur-xl border-t border-foreground-950/10 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="eyebrow text-foreground-800 cursor-pointer"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#book"
            onClick={() => setOpen(false)}
            className="eyebrow px-5 py-3 border border-foreground-950/40 text-foreground-950 text-center cursor-pointer"
          >
            Reserve
          </a>
        </div>
      )}
    </header>
  );
}